<template>
  <div>
    <modal :size="'modal-small'" :close-strict="true" @close="$emit('close')">
      <div slot="header">
        <h4>Send Plan</h4>
      </div>
      <div class="modal-body-scroll" slot="body">
        <div class="loader-circle" v-show="loading" />
        <div class="row send-plan-wrapper">
          <div class="col-md-12 text-center mb-3">
            <h5 class="font-weight-bold">How do you wish to send the plan?</h5>
          </div>
          <div class="col-md-12 text-center mb-2">
            <div class="form-row">
              <div class="col-12 pt-2 pl-0 radio-button-wrap ml-3">
                <label
                  @click="setChannel('email')"
                  class="pointer text-left w-100 h-100 d-flex align-items-center"
                >
                  <input :checked="channel === 'email'" type="radio" id="email" />
                  <span class="btn-radio" />
                  <label for="email" class="btn-radio-label">Email</label>
                </label>
              </div>
              <div class="col-12 pt-2 pl-0 position-relative radio-button-wrap ml-3" :class="[canSendSms ? '' : 'disabled']">
                <label
                  @click.prevent="canSendSms && setChannel('SMS')"
                  class="text-left w-100 h-100 d-flex align-items-center"
                  :class="[canSendSms ? 'pointer' : '']"
                  id="sms-label"
                >
                  <input :checked="channel === 'SMS'" type="radio" id="sms" />
                  <span class="btn-radio" />
                  <label for="sms" class="btn-radio-label">SMS</label>
                </label>
                <div id="smsPopup" style="display: none">
                  Company doesn't have a phone number
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 text-center send-plan-actions mt-4">
            <div class="d-flex align-items-center mt-3">
              <button class="btn btn-secondary" @click.prevent="$emit('close')">
                Cancel
              </button>
            </div>
            <div class="d-flex align-items-center mt-3">
              <button class="btn btn-primary" @click.prevent="sendPlan">
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" />
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import tippy from 'tippy.js';
import toastr from 'toastr';
import Modal from '../../Modal';

export default {
  name: 'SendPlan',
  components: {
    Modal,
  },
  props: {
    job: {
      type: Object,
      default: () => {},
    },
    plan: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    loading: false,
    channel: 'email',
  }),
  computed: {
    canSendSms() {
      return (
        this.job.company.phone_numbers &&
        this.job.company.phone_numbers.find(num => num.type.id === 1)
      );
    },
  },
  mounted() {
    tippy('#sms-label', {
      placement: 'bottom',
      html: '#smsPopup',
    });
  },
  methods: {
    setChannel(value) {
      this.channel = value;
    },
    sendPlan() {
      this.loading = true;
      const data = {
        channel: this.channel,
        job_id: this.job.id,
        plan_code: this.plan.code,
        plan_id: this.plan.recurly_id,
      };
      axios
        .post('recurly/plans', data)
        .then(() => {
          toastr.success('Successfully sent plan');
          this.$emit('close');
          this.$emit('planSent');
        })
        .catch(() => {
          toastr.error('Error sending plan');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.send-plan-wrapper {
  padding: 15px 15px 0 15px;
}
.send-plan-actions {
  display: flex;
  justify-content: space-around;
}
.opacity-2 {
  opacity: 0.2;
}
.loader-circle {
  margin-bottom: 30px;
  border: 3px solid rgba(0, 0, 0, 0);
  border-left-color: #2962ff;
  -webkit-animation: loader-spin 1.2s infinite linear;
  animation: loader-spin 0.7s infinite linear;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  z-index: 10000;
  position: absolute;
  top: 43%;
  right: 40%;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/modals/SendPlan.vue